import script from "./CountDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountDown.vue?vue&type=script&setup=true&lang=ts"

import "./CountDown.vue?vue&type=style&index=0&id=b297f320&scoped=true&lang=scss"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b297f320"]])

export default __exports__